export default "__VITE_ASSET__Dlg3YgUS__"